import { useEffect, useMemo, useState } from 'react'
import NavTable from '../table/NavTable'
import { listTextSearches } from '../../services/textSearches'
import { textSearchLabel } from './textSearchLabel'

// The saved-search list in the Global Text Search nav column. Opening a search
// loads it into the active window (window title = search name). `reloadSignal`
// (bumped after create/rename/delete) forces a refetch.
function TextSearchList({ reloadSignal, selectedId, onSelect }) {
  const [searches, setSearches] = useState([])
  const [status, setStatus] = useState('loading') // loading | ready | error

  useEffect(() => {
    let alive = true
    listTextSearches()
      .then((list) => {
        if (!alive) return
        setSearches(list)
        setStatus('ready')
      })
      .catch(() => alive && setStatus('error'))
    return () => {
      alive = false
    }
  }, [reloadSignal])

  const columns = useMemo(
    () => [
      {
        key: 'name',
        header: 'Search',
        render: (search) => {
          const label = textSearchLabel(search)
          return (
            <span className="nav-ellipsis" title={label}>
              {label}
            </span>
          )
        },
      },
    ],
    []
  )

  if (status === 'loading') return <div className="nav-table-status">Loading…</div>
  if (status === 'error') return <div className="nav-table-status">Could not load searches.</div>

  return (
    <NavTable
      columns={columns}
      rows={searches}
      getRowId={(search) => search._id}
      selectedId={selectedId}
      onRowClick={onSelect}
      showHeader={false}
      emptyLabel="No searches yet. Create one to get started."
    />
  )
}

export default TextSearchList
